import React from "react";

import styled from "styled-components";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import Button from "../../../Button/Button";
import { CgClose } from "react-icons/cg";
import { useGetProdcutList3 } from "../../../../hooks/useContent";
import Typography from "../../../Typography/Typography";
import { Wrapper } from "../../../../theme/GlobalStyle";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Spinner from "react-bootstrap/Spinner";

// levelsProperty={levelsProperty}
// setLevelsProperty={setLevelsProperty}

function GetCategoryLevelThree({
  handleClose,
  show,
  item,
  levelsProperty,
  setLevelsProperty,
}) {
  const {
    data: levelList,
    isFetching: fetchLoading,
    isError: errorReq,
  } = useGetProdcutList3("", "");

  let levelOption = levelList?.pages[0]?.data?.CategoriesLevelTwo?.filter(
    (opti) => opti?.parent?.IdCategories === levelsProperty?.level2?.id
  )?.map((level) => {
    return { value: level?.IdCategories, label: level?.NameCategories };
  });

  const defaultLevelOption = { value: -1, label: "دسته بندی را انتخاب کنید" };

  levelOption?.unshift(defaultLevelOption);

  const handleLevelSelect = (event) => {
    const { value, label } = event;

    setLevelsProperty({
      ...levelsProperty,
      level3: { id: value, name: label },
    });
    handleClose();
  };

  return (
    <BootstrapModal
      modaltitle="انتخاب دسته بندی"
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <DeletePropertyStyle>
        {levelOption?.length < 2 ? (
          <Typography>هیج دسته بندی با توجه به سطح دوم پیدا نشد</Typography>
        ) : (
          <SelectContainer>
            <SimpleSelect1
              label={"دسته بندی سطح 3"}
              placeholder={"دسته بندی انتخاب کنید"}
              res={levelOption}
              onChange={handleLevelSelect}
            />
          </SelectContainer>
        )}
      </DeletePropertyStyle>
    </BootstrapModal>
  );
}

const DeletePropertyStyle = styled.div`
  width: 100%;
  /* height: 80px; */
  height: 50vh;
  background-color: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;

const SelectContainer = styled.div`
  width: 100%;
`;

export default GetCategoryLevelThree;
